import { differenceInMilliseconds, isBefore } from "date-fns";

import { getScheduledEndDate } from "./getScheduledEndDate";

const SHIFT_ENDS_SOON_THRESHOLD = 0.5;

export function getIsShiftEndingSoon(params: {
  shiftStartDate: Date;
  shiftEndDate: Date;
  clockInDate: Date | undefined;
  isCapAtShiftLength: boolean;
  now: Date;
}): boolean {
  const { shiftStartDate, shiftEndDate, clockInDate, isCapAtShiftLength, now } = params;

  const scheduledEndDate = getScheduledEndDate({
    shiftStartDate,
    shiftEndDate,
    clockInDate,
    isCapAtShiftLength,
  });

  const totalDuration = differenceInMilliseconds(scheduledEndDate, shiftStartDate);

  if (totalDuration <= 0) {
    return false;
  }

  if (isBefore(now, shiftStartDate)) {
    return false;
  }

  const elapsed = differenceInMilliseconds(now, shiftStartDate);
  return elapsed / totalDuration >= SHIFT_ENDS_SOON_THRESHOLD;
}
